import { Student, Students } from "@/models/Student"
import { Name } from "@/models/Name"
import { Address } from "@/models/Address"

class Parent {
  constructor(
    values
  ) {
    if (!(typeof values.uuid === "string")) {
      throw new TypeError(`The type of 'uuid' must be String. Actual: ${typeof values.uuid}`)
    }
    if (!(values.name instanceof Name)) {
      throw new TypeError(`'name' must be an instance of [object Name]. Actual: ${typeof values.name}`)
    }
    if (!(typeof values.email === 'string')) {
      throw new TypeError(`The type of 'email' must be String. Actual: ${typeof values.email}`)
    }
    if (!(typeof values.gender === 'string')) {
      throw new TypeError(`The type of 'gender' must be String. Actual: ${typeof values.gender}`)
    }
    if (!(values.birthday instanceof Date)) {
      throw new TypeError(`'birthday' must be an instance of [object Date]. Actual: ${typeof values.birthday}`)
    }
    if (!(typeof values.phone === 'string')) {
      throw new TypeError(`The type of 'phone' must be String. Actual: ${typeof values.phone}`)
    }
    if (!(values.address instanceof Address)) {
      throw new TypeError(`'address' must be an instance of [object Address]. Actual: ${typeof values.address}`)
    }
    if (!(typeof values.nearestStation === 'string')) {
      throw new TypeError(`The type of 'nearestStation' must be String. Actual: ${typeof values.nearestStation}`)
    }
    if (!(values.students instanceof Students)) {
      throw new TypeError(`'students' must be an instance of [object Students]. Actual: ${typeof values.students}`)
    }
    if (!(values.teacherIds instanceof Array)) {
      throw new TypeError(`'teacherIds' must be an instance of [object Array]. Actaul: ${typeof values.teacherIds}`)
    }
    if (!(typeof values.cardId === 'string')) {
      throw new TypeError(`The type of 'cardId' must be String. Actual: ${typeof values.cardId}`)
    }
    if (!(typeof values.active === 'boolean')) {
      throw new TypeError(`The type of 'active' must be Boolean. Actual: ${typeof values.active}`)
    }
    this.uuid = values.uuid
    this.name = values.name,
    this.email = values.email
    this.gender = values.gender
    this.birthday = values.birthday
    this.phone = values.phone
    this.address = values.address
    this.nearestStation = values.nearestStation
    this.students = values.students
    this.teacherIds = values.teacherIds
    this.cardId = values.cardId
    this.createdAt = values.createdAt
    this.updatedAt = values.updatedAt
    this.active = values.active
  }

  toObject() {
    return {
      id: this.uuid,
      data: {
        personalName: this.name.personalName,
        familyName: this.name.familyName,
        flatPersonalName: this.name.flatPersonalName,
        flatFamilyName: this.name.flatFamilyName,
        email: this.email,
        gender: this.gender,
        birthday: this.birthday,
        phone: this.phone,
        postalCode: this.address.postalCode,
        prefecture: this.address.prefecture,
        municipality: this.address.municipality,
        subAddress: this.address.subAddress,
        nearestStation: this.nearestStation,
        students: this.students.toObjects(),
        teacherIds: this.teacherIds,
        cardId: this.cardId,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt,
        active: this.active
      }
    }
  }

  getId() {
    return this.uuid
  }

  hasId(uuid) {
    if (!(typeof uuid === "string")) {
      throw new TypeError(`The type of 'uuid' must be String. Actual: ${typeof uuid}`)
    }
    return (this.uuid === uuid)
  }

  isActive() {
    return this.active
  }

  unsubscribe() {
    this.active = false
    return this
  }

  fullName() {
    return this.name.fullName()
  }

  fullAddress() {
    return this.address.fullAddress()
  }

  genderInJapanese() {
    return (this.isMale()) ? "男性" : "女性"
  }

  isMale () {
    return (this.gender === "male")
  }

  birthdayToString() {
    const t = this.birthday.getFullYear()
    const m = this.birthday.getMonth() + 1
    const d = this.birthday.getDate()
    return t + "年" + m + "月" + d + "日"
  }

  registerStudent(student) {
    if (!(student instanceof Student)) {
      throw new TypeError(`'student' must be instance of [object Student]. Actual: ${typeof student}`)
    }
    this.students.register(student)
    return this
  }

  updateStudent(student) {
    if (!(student instanceof Student)) {
      throw new TypeError(`'student' must be instance of [object Student]. Actual: ${typeof student}`)
    }
    this.students.update(student)
    return this
  }

  getTeacherIds () { return this.teacherIds }

  registerTeacherId(teacherId) {
    if (!(typeof teacherId === "string")) {
      throw new TypeError(`The type of 'teacherId' must be String. Actual: ${typeof teacherId}`)
    }
    if (this.teacherIds.includes(teacherId)) {
      return this
    } else {
      this.teacherIds.push(teacherId)
      return this
    }
  }

  removeTeacherId(teacherId) {
    if (!(typeof teacherId === "string")) {
      throw new TypeError(`The type of 'teacherId' must be String. Actual: ${typeof teacherId}`)
    }
    if (this.getStudents().filterByTeacherId(teacherId).length() === 0) {
      this.teacherIds.splice(this.teacherIds.findIndex(id => id === teacherId), 1)
    }
    return this
  }

  getStudents() {
    return this.students
  }

  findStudent(studentId) {
    if (!(typeof studentId === "string")) {
      throw new TypeError(`The type of 'studentId' must be String. Actual: ${typeof studentId}`)
    }
    return this.students.find(studentId)
  }

  deleteStudent(studentId) {
    if (!(typeof studentId === "string")) {
      throw new TypeError(`The type of 'studentId' must be String. Actual: ${typeof studentId}`)
    }
    this.students.remove(studentId)
    return this
  }

}

export { Parent }